export default __webpack_public_path__ + "static/media/FB.77475163.svg";